// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Compare_wrapper__2ozAv","content":"Compare_content__hfS1K"};